module.exports = __webpack_public_path__ + "img/M4_JKKP_08.0e3841e2.png";